import { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import CustomCard from "../../../components/card/CustomCard";
import PageHeader from "../../../layout/shared/page-header";
import { menuRoutes } from "../../../router/menu";
import { RoleService } from "../../../services/role/roleService";
import RoleForm from "../RoleForm";

const pageHeader = {
    title: "Crear Rol",
    breadcrumb: [
        {
            href: menuRoutes.roles.path,
            name: "Roles",
        },
        {
            name: "Crear",
        },
    ],
};

const RoleCreate: FC = () => {

    // STATES

    const [loading, setLoading] = useState<boolean>(false);

    // HOOKS

    const navigate = useNavigate();
    const service = new RoleService();

    // FUNCTIONS

    //--------------------------------------------------------------------------------------------------------------
    /**
     * @ES MANEJAR EL ENVIO DEL FORMULARIO DE CREACION
     * @EN HANDLE THE SUBMIT OF THE CREATE FORM
     *
     * @param values
     * @param permissions
     */
    //--------------------------------------------------------------------------------------------------------------
    const handleSubmit = async (values: any, permissions: number[]) => {
        setLoading(true);
        values.permissions = permissions;

        try {
            const response = await service.createRole(values);
            const responseData = response.getResponseData();

            if (responseData.success) {
                navigate(-1);
                toast.success("Rol creado correctamente");
            } else {
                responseData.data.errors.forEach((error: any) => {
                    toast.error(error.message);
                });
            }
        } catch (error: any) {
            toast.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    //--------------------------------------------------------------------------------------------------------------

    // RENDER

    return (
        <>
            <PageHeader title={pageHeader.title} breadcrumb={pageHeader.breadcrumb} />

            <CustomCard title="Datos Principales" className="mb-4">
                <RoleForm submit={handleSubmit} isLoading={loading} />
            </CustomCard>
        </>
    );
};

export default RoleCreate;